<div class="previous-periods-filter-panel">
  <div class="panel-header">
    <h3>Filter Previous Periods</h3>
    <button type="button" class="close-button" (click)="onClose()" title="Close without applying">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="panel-body">
    <p *ngIf="(availablePeriods?.length || 0) === 0" class="empty-message">
      No previously completed periods are available for this template.
    </p>
    <ul *ngIf="(availablePeriods?.length || 0) > 0" class="period-list">
      <li *ngFor="let p of availablePeriods" class="period-item">
        <label class="period-row row">
            <div class="col-sm-1 checkbox-container">
              <input
                type="checkbox"
                [checked]="isChecked(p.periodKey)"
                (change)="toggle(p.periodKey)"
              />
            </div>
            <div class="col-sm-11 item-description">
                <span class="date-row">
                    <span class="period-date">{{ p.statementDate }}</span>
                    <span class="period-badge">Previous Spread</span>
                </span>
                <span class="period-summary">
                    <span class="period-meta">{{ reportingIntervalDisplay(p.reportingInterval) }}</span>
                    <span class="period-sep">·</span>
                    <span class="period-meta">{{ scenarioDisplay(p.scenario) }}</span>
                    <span class="period-sep">·</span>
                    <span class="period-meta">{{ preparationTypeDisplay(p.preparationType) }}</span>
                </span>
            </div>

        </label>
      </li>
    </ul>
  </div>

  <div class="panel-footer">
    <button type="button" class="btn btn-empty-primary" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onApply()"
      [disabled]="!hasChanges"
    >
      Apply Filters
    </button>
  </div>
</div>
